import { Energyform, Productionform, Socialform, Form } from "../../api";
import { energyCodes, energyKPIsCodes, energyFormulasIndicators, convertUnitsFinal } from "./energyForms";
import { computeRealKpiValue } from "./kpiRealValue";

const energyController = new Energyform();
const productionController = new Productionform();
const socialController = new Socialform();
const formController = new Form();

// código KPI ("KPIene1") -> field key ("electricity_standard_combined_kpis"),
// el que espera el switch de energyFormulasIndicators. Inverso de energyKPIsCodes.
const CODE_TO_FIELD = Object.fromEntries(
  Object.entries(energyKPIsCodes).map(([field, code]) => [code, field])
);

const RAW_FIELDS = Object.keys(energyCodes);

/** Lee el valor REAL de un KPI de Energía (sitio + año). Ver kpiRealValue.js. */
export async function getRealEnergyKpiValue({ accessToken, site, kpiCode, year }) {
  const fieldKey = CODE_TO_FIELD[kpiCode];
  if (!fieldKey) return { available: false, reason: "unknown_kpi" };

  return computeRealKpiValue({
    accessToken,
    site,
    year,
    fieldKey,
    rawFields: RAW_FIELDS,
    formulasFn: energyFormulasIndicators,
    convertFn: convertUnitsFinal,
    getRecordsFn: (t, s, ys) => energyController.getEnergyFormsByLastYears(t, s, ys),
    recordsWrapperKey: "energyForms",
    getUnitsFn: (t, s, y, f) => energyController.getLastUnitFieldsByYear(t, s, y, f),
    getBaselineFn: (t, s, y) => productionController.getTotalBaselineByYearAndSite(t, s, y, "standardized_production"),
    getWorkersFn: (t, s, ys) => socialController.getTotalWorkersByYears(t, s, ys),
    getConfigFn: (t, s, moduleName, active) => formController.getFormsBySite(t, s, moduleName, active),
    moduleName: "energy",
  });
}
